import React from "react";
import ButtonBase from "@mui/material/ButtonBase";
import { getClassName } from "@sscs/utils";
import { ChevronLeftIcon as ChevronLeft, ChevronRightIcon as ChevronRight, } from "../../icons";
import Button from "../Button/Button";
import styles from "./carousel.module.scss";
const Carousel = ({ activeIndex, itemsCount, onChange, }) => {
    return (React.createElement("div", { className: styles.carousel },
        React.createElement(Button, { variant: "text", size: "small", disabled: activeIndex === 0, onClick: () => onChange(activeIndex - 1), startIcon: React.createElement(ChevronLeft, null) }, "Previous"),
        React.createElement("div", { className: styles["item-navigation"] }, Array(itemsCount)
            .fill(0)
            .map((_, index) => (React.createElement(ButtonBase, { className: getClassName(styles.item, {
                [styles["item-active"]]: activeIndex === index,
            }), key: index, onClick: () => onChange(index), "aria-label": index.toString() })))),
        React.createElement(Button, { variant: "text", size: "small", disabled: activeIndex === itemsCount - 1, onClick: () => onChange(activeIndex + 1), endIcon: React.createElement(ChevronRight, null) }, "Next")));
};
export default Carousel;
//# sourceMappingURL=Carousel.js.map